import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true,
      forceUpdateUser: true,
    }
  },
  // {
  //   path: '/summary',
  //   name: 'Summary',
  //   component: () => import('../views/Summary.vue'),
  //   meta: {
    //   requiresAuth: true,
    // forceUpdateUser: true,
    //   }
  // },
  {
    path: '/my-stats',
    name: 'MyStats',
    component: () => import('../views/MyStats.vue'),
    meta: {
      requiresAuth: true,
      forceUpdateUser: true,
    }
  },
  {
    path: '/weekly-scores',
    name: 'Weekly Scores',
    component: () => import('../views/WeeklyScores.vue'),
    meta: {
      requiresAuth: true,
      forceUpdateUser: true,
    }
  },
  {
    path: '/league',
    name: 'League',
    component: () => import('../views/League.vue'),
    meta: {
      requiresAuth: true,
      forceUpdateUser: true,
    }
  },
  {
    path: '/sudden-death',
    name: 'Sudden Death',
    component: () => import('../views/SuddenDeath.vue'),
    meta: {
      requiresAuth: true,
      forceUpdateUser: true,
    }
  },
  {
    path: '/sudden-death/week/:weekId',
    name: 'Sudden Death Week',
    component: () => import('../views/SuddenDeathWeek.vue'),
    meta: {
      requiresAuth: true,
      forceUpdateUser: true,
    }
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('../views/Chat.vue'),
    meta: {
      requiresAuth: true,
      forceUpdateUser: true,
    }
  },
  {
    path: '/preferences',
    name: 'Preferences',
    component: () => import('../views/Preferences.vue'),
    meta: {
      requiresAuth: true,
      forceUpdateUser: true,
    }
  },
  {
    path: '/update-info',
    name: 'UpdateUserInfo',
    component: () => import('../views/UpdateUserInfo.vue'),
    meta: {
      requiresAuth: true,
      redirectHomeIfInfoComplete: true,
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    meta: { loggedOutOnly: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue'),
    meta: { loggedOutOnly: true }
  },
  {
    path: '/reset_password',
    name: 'Reset Password',
    component: () => import(/* webpackChunkName: "register" */ '../views/ResetPassword.vue'),
    meta: { loggedOutOnly: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

  const loggedIn = localStorage.getItem('tenp_user')

  // REQUIRES AUTH
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/login');
  }

  // REQUIRES AUTH BUT MISSING NAME INFO
  if (
    to.matched.some(record => record.meta.requiresAuth)
    && to.matched.some(record => record.meta.forceUpdateUser)
    && loggedIn
    && (!JSON.parse(loggedIn).first_name || !JSON.parse(loggedIn).surname)
  ) {
    router.push('/update-info').catch(e => {})
  }

  // REDIRECT AWAY FROM /update-info WHEN INFO IS UPDATED
  if (
    to.matched.some(record => record.meta.redirectHomeIfInfoComplete)
    && loggedIn
    && (JSON.parse(loggedIn).first_name)
  ) {
    router.push('/').catch(e => {})
  }

  //LOGGED OUT ONLY
  if (to.matched.some(record => record.meta.loggedOutOnly) && loggedIn) {
    next('/');
  }
    
  next()
})

export default router
